const state = {
  type: null,
  message: null
};

const actions = {
  success({ commit }, message) {
    commit("success", message);
  },
  error({ commit }, message) {
    commit("error", message);
  },
  info({ commit }, message) {
    commit("info", message);
  },
  clear({ commit }) {
    commit("clear");
  }
};

const mutations = {
  success(state, message) {
    state.type = "is-success";
    state.message = message;
  },
  error(state, message) {
    state.type = "is-danger";
    state.message = message;
  },
  info(state, message) {
    state.type = "is-info";
    state.message = message;
  },
  clear(state) {
    state.type = null;
    state.message = null;
  }
};

export const alert = {
  namespaced: true,
  state,
  actions,
  mutations
};
